<template>
    <v-form ref="form" v-on:submit="speichern">
        <v-container justify-space-between>
            <v-card-title>
                <span class="headline">neuer Eintrag</span>
            </v-card-title>
            <v-card-text>
                <v-layout row>
                    <v-flex sm4>
                        <v-menu
                            v-model="menuDatum"
                            :close-on-content-click="false"
                            lazy
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value="formatDatum"
                                    label="Datum"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="vorgang.datum"
                                @change="menuDatum = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>

                    <v-flex sm8>
                        <v-autocomplete
                            ref="autoTechniker"
                            v-model="vorgang.techniker"
                            :items="techniker"
                            item-text="nummer"
                            item-value="id"
                            class="mx-3"
                            label="Techniker"
                            prepend-icon="account_box"
                            return-object
                            data-vv-name="vorgang.techniker"
                            data-vv-as="Techniker"
                            v-validate="'required'"
                            :error-messages="errors.collect('vorgang.techniker')"
                        >
                        </v-autocomplete>
                    </v-flex>
                </v-layout>

                <v-layout row mt-2>
                    <v-flex sm6>
                        <v-autocomplete
                            ref="autoArzt"
                            v-model="vorgang.arzt"
                            :items="aerzte"
                            :hide-no-data="dialogNeueAdresseZahnarzt"
                            item-text="name"
                            item-value="id"
                            label="Zahnarzt"
                            prepend-icon="enhanced_encryption"
                            @keypress.enter.prevent="adresseSpeichern('zahnarzt')"
                            return-object
                            data-vv-name="vorgang.arzt"
                            data-vv-as="Zahnarzt"
                            v-validate="'required'"
                            :error-messages="errors.collect('vorgang.arzt')"
                        >
                            <template v-slot:selection="data">
                                <span>{{ data.item.name }}</span>
                                <small class="grey--text">, {{ data.item.ort }}</small>
                            </template>

                            <template v-slot:item="data">
                                <template>
                                    <v-list-tile-content>
                                        <v-list-tile-title
                                            v-html="data.item.name"
                                        ></v-list-tile-title>
                                        <v-list-tile-sub-title
                                            v-html="data.item.ort"
                                        ></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>

                            <template v-slot:no-data>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Zahnarzt ist nicht vorhanden. <kbd>Enter</kbd> drücken für
                                            Neuanlage.
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-autocomplete>

                        <v-dialog v-model="dialogNeueAdresseZahnarzt" width="860">
                            <NeuerAdresseform
                                :dialog="dialogNeueAdresseZahnarzt"
                                typ="Zahnarzt"
                                :val="val"
                                @close="dialogNeueAdresseZahnarzt = false"
                                @neueAdresse="neueAdresse($event)"
                            ></NeuerAdresseform>
                        </v-dialog>
                    </v-flex>

                    <v-flex sm6>

                        <v-text-field
                            v-model="vorgang.patient"
                            label="Patient"
                            type="text"
                            prepend-icon="airline_seat_recline_extra"
                            data-vv-name="patient"
                            data-vv-as="Patient"
                            :error-messages="errors.collect('patient')"
                            v-validate="'required'"
                        >
                        </v-text-field>

                        <!--<v-autocomplete-->
                        <!--ref="autoPatient"-->
                        <!--v-model="vorgang.patient"-->
                        <!--:items="patienten"-->
                        <!--:hide-no-data="dialogNeueAdressePatient"-->
                        <!--item-text="name"-->
                        <!--item-value="id"-->
                        <!--label="Patient"-->
                        <!--prepend-icon="airline_seat_recline_extra"-->
                        <!--@keypress.enter.prevent="adresseSpeichern('patient', vorgang.patient)"-->
                        <!--return-object-->
                        <!--data-vv-name="vorgang.patient"-->
                        <!--data-vv-as="Patient"-->
                        <!--v-validate="'required'"-->
                        <!--:error-messages="errors.collect('vorgang.patient')"-->
                        <!--&gt;-->
                        <!--<template v-slot:selection="data">-->
                        <!--<span>{{ data.item.name }}</span>-->
                        <!--<small class="grey&#45;&#45;text" v-if="data.item.ort">, {{ data.item.ort }}</small>-->
                        <!--</template>-->

                        <!--<template v-slot:item="data">-->
                        <!--<v-list-tile-content>-->
                        <!--<v-list-tile-title-->
                        <!--v-html="data.item.name"-->
                        <!--&gt;</v-list-tile-title>-->
                        <!--<v-list-tile-sub-title-->
                        <!--v-html="data.item.ort"-->
                        <!--&gt;</v-list-tile-sub-title>-->
                        <!--</v-list-tile-content>-->
                        <!--</template>-->

                        <!--<template v-slot:no-data>-->
                        <!--<v-list-tile>-->
                        <!--<v-list-tile-content>-->
                        <!--<v-list-tile-title>-->
                        <!--Patient ist nicht vorhanden. <kbd>Enter</kbd> drücken für-->
                        <!--Neuanlage.-->
                        <!--</v-list-tile-title>-->
                        <!--</v-list-tile-content>-->
                        <!--</v-list-tile>-->
                        <!--</template>-->
                        <!--</v-autocomplete>-->

                        <!--<v-dialog v-model="dialogNeueAdressePatient" width="860">-->
                        <!--<NeuerAdresseform-->
                        <!--:dialog="dialogNeueAdressePatient"-->
                        <!--typ="Patient"-->
                        <!--:val="val"-->
                        <!--@close="dialogNeueAdressePatient = false"-->
                        <!--@neueAdresse="neueAdresse($event)"-->
                        <!--&gt;</NeuerAdresseform>-->
                        <!--</v-dialog>-->
                    </v-flex>
                </v-layout>

                <v-layout row mt-2>
                    <v-flex xs12 sm6>
                        <v-autocomplete
                            ref="autoMaterial"
                            v-model="vorgang.material"
                            :items="materialien"
                            :auto-select-first="true"
                            :hide-selected="false"
                            :hide-no-data="confirmMaterial"
                            :search-input.sync="search"
                            item-text="name"
                            item-value="id"
                            cache-items
                            label="Goldsorte"
                            prepend-icon="list_alt"
                            return-object
                            data-vv-name="material"
                            data-vv-as="Material"
                            :error-messages="errors.collect('material')"
                            v-validate="'required'"
                            style="z-index: 204"
                        >
                            <template v-slot:no-data class="d-none">
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Material nicht vorhanden.
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-autocomplete>

                        <v-dialog
                            v-model="confirmMaterial"
                            max-width="320px"
                            :persistent="true"
                            style="z-index:10"
                        >
                            <v-card>
                                <v-card-title class="headline grey lighten-2" primary-title>
                                    Material nicht vorhanden
                                </v-card-title>

                                <v-card-text>
                                    Soll das Material "<strong>{{ search }}</strong
                                >" angelegt werden
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>

                                    <v-btn
                                        color="black darken-5"
                                        flat="flat"
                                        @click="confirmMaterial = false"
                                    >
                                        Nein
                                    </v-btn>

                                    <v-btn
                                        color="green darken-1"
                                        flat="flat"
                                        @click="materialSpeichern(search)"
                                    >
                                        JA
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-flex>

                    <v-flex>
                        <v-select
                            v-model="vorgang.arbeitsart"
                            :items="arbeitsarten"
                            item-text="name"
                            item-value="id"
                            label="Art der Arbeit"
                            prepend-icon="clear_all"
                            data-vv-name="art"
                            data-vv-as="Art der Arbeit"
                            :error-messages="errors.collect('art')"
                            v-validate="'required'"
                        >
                        </v-select>
                    </v-flex>

                    <v-flex>
                        <v-text-field
                            v-model="vorgang.gussgewicht"
                            label="Gussgewicht in gr."
                            type="number"
                            step=".01"
                            prepend-icon="play_for_work"
                            data-vv-name="gussgewicht"
                            data-vv-as="Gussgewicht"
                            :error-messages="errors.collect('gussgewicht')"
                            v-validate="'required'"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row mt-2>
                    <v-flex>
                        <v-text-field
                            v-model="vorgang.kommentar"
                            label="Kommentar"
                            type="text"
                            prepend-icon="speaker_notes"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="black darken-5" flat="flat" @click="$emit('close')">
                    Abbrechen
                </v-btn>

                <v-btn color="success" flat="flat" type="submit">
                    Speichern
                </v-btn>
            </v-card-actions>
        </v-container>

        <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            :absolute="false"
            :bottom="true"
            :left="true"
        >
      <span>
        <v-icon color="success" left>check</v-icon>
        {{ snackbarText }}
      </span>
        </v-snackbar>
    </v-form>
</template>

<script type="text/babel">
    import {mapState, mapGetters} from "vuex";
    import moment from "moment";
    import NeuerAdresseform from "@/components/NeuerAdresseform.vue";

    export default {
        components: {
            NeuerAdresseform
        },
        props: {
            dialog: Boolean,
            eintrag: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data() {
            return {
                clickSpeichern: false,
                vorgang: {
                    id: null,
                    arzt: null,
                    patient: null,
                    techniker: null,
                    material: null,
                    art: null,
                    arbeitsart: null,
                    gussgewicht: null,
                    kommentar: null,
                    adresse_id: 1,
                    datum: moment().format("YYYY-MM-DD")
                },
                arzt: {},
                name: null,
                menuDatum: false,
                confirmMaterial: false,
                dialogNeueAdresseZahnarzt: false,
                dialogNeueAdressePatient: false,
                snackbar: false,
                snackbarText: null,
                search: null,
                val: null
            };
        },
        mounted() {
            this.$store.dispatch("loadTechniker");
            this.$store.dispatch("loadAdressen");
            this.$store.dispatch("loadMaterialien");
            this.$store.dispatch("loadArbeitsarten");
        },
        computed: {
            ...mapState(["materialien", "techniker", "arbeitsarten"]),
            ...mapGetters(["aerzte", "patienten"]),
            formatDatum() {
                return this.vorgang.datum
                    ? moment(this.vorgang.datum).format("DD.MM.YYYY")
                    : "";
            }
        },
        watch: {
            dialog() {
                if (this.dialog) {
                    if (this.eintrag) {
                        this.$nextTick(() => {
                            // this.eintrag.patient = this.eintrag.adresse;
                            this.vorgang = Object.assign(this.vorgang, this.eintrag);
                        });
                    }
                    this.$validator.reset();
                    Object.assign(this.vorgang, this.$options.data.call(this).vorgang);
                }
            },
            dialogNeueAdresseZahnarzt() {
                if (this.dialogNeueAdresseZahnarzt === false)
                    this.$nextTick(() => this.$refs.autoArzt.focus());
            },
            dialogNeueAdressePatient() {
                if (this.dialogNeueAdressePatient === false)
                    this.$nextTick(() => this.$refs.autoPatient.focus());
            },
            snackbarText() {
                this.snackbar = this.snackbarText.length;
            }
        },
        methods: {
            // materialSpeichern(name) {
            //     if (this.vorgang.material && this.vorgang.material.name == name) return;
            //     this.$store.dispatch("addMaterial", {name: name}).then(() => {
            //         const n = this.materialien.find(m => m.name == name);
            //         if (n) this.$refs.autoMaterial.selectItem(n);
            //         this.snackbarText = "Material wurde gespeichert";
            //     });
            // },
            adresseSpeichern(typ, wert) {
                const refs = {
                    zahnarzt: "autoArzt",
                    patient: "autoPatient"
                };
                const val = this.$refs[refs[typ]].$el.querySelector("input").value;
                this.val = val;
                if (!val.length) return;
                switch (typ) {
                    case "zahnarzt":
                        if (
                            this.vorgang.arzt &&
                            this.$refs.autoArzt.$el.querySelector("input").value ==
                            this.vorgang.arzt.name
                        )
                            return;
                        this.dialogNeueAdresseZahnarzt = true;
                        break;
                    case "patient":

                        if (this.vorgang.patient && val == this.vorgang.patient.name) return;
                        // this.dialogNeueAdressePatient = true;
                        this.dialogNeueAdressePatient = true;
                        break;
                }
            },
            neueAdresse(adresse) {
                if (adresse.typ == "Patient") {
                    const p = this.patienten.find(
                        p =>
                            p.vorname == adresse.vorname &&
                            p.nachname == adresse.nachname &&
                            p.ort == adresse.ort
                    );
                    if (p) this.$refs.autoPatient.selectItem(p);
                    this.dialogNeueAdressePatient = false;
                } else {
                    const a = this.aerzte.find(
                        a => a.vorname == adresse.vorname && a.nachname == adresse.nachname
                    );
                    if (a) this.$refs.autoArzt.selectItem(a);
                    this.dialogNeueAdresseZahnarzt = false;
                }
            },
            speichern: function () {
                if (this.clickSpeichern) return console.log('Kein dblClick');
                this.clickSpeichern = true;
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    const dispatch = this.vorgang.id ? "updateVorgang" : "addVorgang";
                    Object.assign(this.vorgang, {
                        techniker_id: this.vorgang.techniker.id,
                        adresse_id: 1,//this.vorgang.patient.id,
                        material_id: this.vorgang.material.id,
                        arzt_id: this.vorgang.arzt.id,
                        art: this.vorgang.arbeitsart.id
                    });

                    this.$store.dispatch(dispatch, this.vorgang).then(() => {
                        this.$emit("close");
                    }).finally(() => {
                        this.clickSpeichern = false;
                    });
                });
                // .catch(err => console.error(err));
            }
        }
    };
</script>
